import { type ProjectInfo, type PublishedProjectInfo } from '@blaze-shared/api-contracts-domain';

export function isCustomerPortalProject(
  projectInfo: ProjectInfo | PublishedProjectInfo | undefined,
): boolean {
  if (!projectInfo) {
    return false;
  }
  if ('isCustomerPortal' in projectInfo) {
    return !!projectInfo.isCustomerPortal;
  } else if ('projectSettingsInfo' in projectInfo) {
    return !!projectInfo.projectSettingsInfo.isCustomerPortal;
  }
  return false;
}
